// This page is basically almost a copy of employee_leave_entry HOWEVER, this is from the admin's point of view so its not a request but forced saving of a leave entry
import template from './insert_leave_entry.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';

class InsertLeaveEntryViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.leave_type_id = ko.observable();
		this.available_leave_types = ko.observableArray();
		this.date_start = ko.observable();
		this.date_end = ko.observable();
		this.amount = ko.observable(0);
		this.is_overlapping = ko.observable();
		this.is_amount_editable = ko.observable();
		this.amount_info = ko.observable('');
		this.reason = ko.observable();
		this.leave_taken_id = ko.observable();
		this.available_leave_types = ko.observableArray();
		this.leave_linked_id = ko.observable();
		this.taken_rate = ko.observable();
		this.leave_summary = ko.observableArray();
		this.summary_filter_earned_end = ko.observable(Utils.toJSONDateString(new Date())); // today
		this.has_attachment = ko.observable(false);
		this.customization_front_end_fields = ko.observableArray();
		this.today = ko.observable(Utils.toJSONDateString(new Date()));
		this.holidays = ko.observableArray([]);
		this.event_dates = ko.observableArray([]);
		this.start_date_picker = null;
		this.end_date_picker = null;

		$('input[id=batch_file]').change((event) => {
			let file = event.target.files[0]
			if (file)
			{
				$('#upload_input').val(file.name)
				this.has_attachment(true)
			}
			else
			{
				$('#upload_input').val('')
				this.has_attachment(false)
			}
		});

		this.leave_linked_id.subscribe((val) => {
			let leave_selected_id = val;
			this.dialog.calc_everything();
			this.dialog.load_customization_fieds(leave_selected_id);
		});

		this.date_start.subscribe((val) => {
			if (val)
			{
				this.end_date_picker.set('minDate', val); // Ensure end date can't be before start date
				this.date_end(val); // Set the end date to the next work day
				this.end_date_picker.setDate(this.date_end()); // Set the date to the current end date
				this.start_date_picker.close(); // Close the start date picker
			}
			this.dialog.calc_everything(); 
		});
		
		this.date_end.subscribe((val) => {
			if (val) {
				this.end_date_picker.close();
				this.dialog.calc_everything(); 
			}
		});
	};

	close()
	{
		this.dialog.close();
	}

	async save_leave()
	{
		this.dialog.global_save_ok = true; // reset
		this.dialog.leave_restriction_queue = new Array(); // reset
		document.getElementById("save_button").disabled = true;

		// convert ko object to normal object
		let data_fields = ko.toJS(this.customization_front_end_fields());

		let data = {
			employee_id: this.dialog.bindings.employee_id,
			leave_type_id: this.leave_type_id(),
			date_start: this.date_start(),
			leave_linked_id: this.leave_linked_id(),
			date_end: this.date_end(),
			is_amount_editable: this.is_amount_editable(),
			amount: this.amount(),
			reason: this.reason(),
			amount_info: this.amount_info(),
			taken_rate: this.taken_rate(),
			is_overlapping: this.is_overlapping(),
			force_request: false
		};

		// add custom frontend fields
		for (let a = 0; a < data_fields.length; a++)
		{
			data[data_fields[a].vname] = data_fields[a].value;
		}

		// validation
		let valid = true;
		let msg = '';

		if (document.getElementById('batch_file').files[0])
		{
			if (document.getElementById('batch_file').files[0].size > 20000000)
			{
				valid = false;
				msg = 'File size exceeds the maximum limit of 20MB';
			}
		}

		if (!data.date_start)
		{
			valid = false;
			msg = 'Please make sure your start date is correct before saving';
		}
		else if (!data.date_end)
		{
			valid = false;
			msg = 'Please make sure your end date is correct before saving';
		}
		else if (isNaN(Number(data.amount)) || Number(data.amount) <= 0)
		{
			valid = false;
			msg = 'Please make sure your amount of days is a positive number';
		}
		else if (data.date_end == data.date_start && Number(data.amount) > 1)
		{
			let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Please note that you are trying to save a value greater than 1 for a single day. This is not recommended. Do you wish to save anyway?')});
			if (response) {}
			else
			{
				valid = false;
				msg = 'Leave not saved - cancelled by user.';
			}
		}
		else if (data.is_overlapping == true)
		{
			let response = await Grape.alerts.confirm({
				type: 'warning', title: tr('Warning'), message: tr('Please note that you are trying to save leave that is overlapping current leave processed. Do you wish to save anyway?')});
			if (response) {}
			else
			{
				valid = false;
				msg = 'Leave not saved - cancelled by user.';
			}
		}

		// do some additional checks
		if (valid == true)
		{
			let res = await Grape.fetches.postJSON('/leave/check_leave_restrictions', data);
			if (res.status == 'OK')
			{
				// check for restriction failures and apply logic based on bahaviours
				if (res.restriction_results != null)
				{
					// Add all failed restrictions to the queue for processing
					for (let a = 0; a < res.restriction_results.length; a++)
					{
						let restriction_result = res.restriction_results[a];
						if (restriction_result.result == 'FAILURE')
							this.dialog.leave_restriction_queue.push(restriction_result);
					}
					this.dialog.process_NEXT_leave_restriction_queue_item(data);
				}
				else
					this.dialog.process_NEXT_leave_restriction_queue_item(data);
			}
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				document.getElementById("save_button").disabled = false;
			}
			else
			{
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
				document.getElementById("save_button").disabled = false;
			}
		}
		
		document.getElementById("save_button").disabled = false;
		//Grape.alerts.alert({ type: 'error', message: tr(msg, msg), title: tr('Error', 'Error') });
	};

	initialize_datepickers(res_requests)
	{
		let calendar_config = {
			dateFormat: 'Y-m-d',
			allowInput: true,
			onDayCreate: (dObj, dStr, fp, dayElem) => {
				let date_string = new Date(dayElem.dateObj.getTime() - (dayElem.dateObj.getTimezoneOffset() * 60000))
				.toISOString()
				.split('T')[0];
			

				let event = this.event_dates().find(e => e.date === date_string);
				
				if (event)
				{
					dayElem.classList.add(event.css_class);
					dayElem.style.backgroundColor = event.hexcolor;
					dayElem.setAttribute('title', event.name);
				}

				if (date_string == this.today)
				{
					dayElem.classList.add('today');
				}
			},
			appendTo: document.body, // This ensures the calendar is appended to the body
			static: true, // This prevents the calendar from being constrained within its parent container
		};

		this.start_date_picker = flatpickr('#datepicker_start', {
			...calendar_config,
			defaultDate: this.date_start() || null
		});
		
		this.end_date_picker = flatpickr('#datepicker_end', {
			...calendar_config,
			defaultDate: this.date_end() || null
		});
	}

	async load_events()
	{
		try
		{
			let res_requests = await Grape.fetches.postJSON('/leave/get_leave_taken_and_requests', { employee_id: this.dialog.bindings.employee_id });
			if (res_requests.status !== 'ERROR')
			{
				this.parse_leave(res_requests);
				if (this.start_date_picker && this.end_date_picker)
				{
					this.start_date_picker.destroy(); // Destroy existing pickers
					this.end_date_picker.destroy(); // Destroy existing pickers
				}
				
				this.initialize_datepickers(res_requests);
			}
		} catch (error)
		{
			Grape.alerts.alert({ type: 'error', message: tr('Failed to load leave and holiday data'), title: tr('Error') });
		}
	}
	
	parse_leave(res)
	{
		let event_dates = [];

		// Parse finalized leave
		if (res.all_finalized_leave && res.all_finalized_leave.length > 0)
			event_dates = event_dates.concat(this.parse_final_leave(res.all_finalized_leave));

		// Parse leave to approve - BUT skip rejected leave requests
		if (res.all_leave_to_approve && res.all_leave_to_approve.length > 0)
		{
			// Filter out rejected leave requests before processing
			let approvedLeaveRequests = res.all_leave_to_approve.filter(leave => leave.approved !== 'rejected');
		
			if (approvedLeaveRequests.length > 0)
			{
				let requestedDates = this.parse_final_dates(approvedLeaveRequests.flatMap(leave => leave.dates_included));
				event_dates = event_dates.concat(requestedDates);
			}
		}

		// Parse holidays (assuming holidays are included in the response)
		if (this.holidays && this.holidays().length > 0)
		{
			let holiday_dates = this.parse_holidays(this.holidays());
			event_dates = event_dates.concat(holiday_dates);
		}

		this.event_dates(event_dates);
	}
	
	parse_final_leave(finalizedLeave)
	{
		return finalizedLeave.flatMap(leave =>
			leave.dates_included.map(date => ({
				date: date,
				css_class: leave.css_class_name,
				hexcolor: leave.hexcolor,
				name: `${leave.leave_type} (Finalised)`
			}))
		);
	}
	
	parse_final_dates(dateArray)
	{
		return dateArray.map(date => ({
			date: date,
			css_class: 'request_date',
			hexcolor: '#fff3cd',
			name: 'Requested Leave day'
		}));
	}
	
	parse_holidays(holidays)
	{
		return holidays.map(holiday => ({
			date: holiday.holiday_date,
			css_class: holiday.css_class_name,
			hexcolor: holiday.hexcolor,
			name: holiday.description
		}));
	}

};

class InsertLeaveEntryPage
{
	constructor (bindings)
	{
		this.viewModel = new InsertLeaveEntryViewModel(this);
		this.bindings = bindings;
		this.global_save_ok = true;
		this.leave_restriction_queue = [];

		document.querySelector('.ps-dialog').classList.add('insert-leave-entry-dialog');
	}

	async load_customization_fieds(_leave_linked_id)
	{
		if (_leave_linked_id == undefined || _leave_linked_id == null || _leave_linked_id == 'undefined')
		{
			document.getElementById("save_button").disabled = true;
			Grape.alerts.alert({type: 'error', message: tr('Employee has no leave linked'), title: tr('Error', 'Error')});
			return; 
		}

		let res = await Grape.fetches.postJSON('/leave/get_frontend_customization_fields', { leave_linked_id: _leave_linked_id });
		if (res.status == 'OK')
		{
			// this.viewModel.amount(res.amount_days);
			if (res.front_end_customization_fields != null)
			{
				// parse into normal array
				let nicer_array = new Array();
				for (let a = 0; a < res.front_end_customization_fields.length; a++)
				{
					let obj = res.front_end_customization_fields[a].customization_frontend_fields;
					// loop over object keys
					Object.keys(obj).forEach((key) => {
						let nice_obj = obj[key]; // copy over
						nice_obj.vname = key;

						nicer_array.push(nice_obj);
					});
				}

				this.viewModel.customization_front_end_fields(nicer_array);
			}
			else
				this.viewModel.customization_front_end_fields.removeAll();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
			document.getElementById("save_button").disabled = false;
		}
		else
		{
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
			document.getElementById("save_button").disabled = false;
		}
	};

	async calc_everything()
	{
		if (!(this.viewModel.date_start() || !this.viewModel.date_end()))
			return;

		// we are forcing people to make use of suggested day, but if they are entering for one date only
		// we are enabling the amount field so they can enter half a day etc.
		let sd = moment(this.viewModel.date_start(), "YYYY-MM-DD", true);
		let ed = moment(this.viewModel.date_end(), "YYYY-MM-DD", true);
	
		// Check if both dates are valid and fully entered
		if (!sd.isValid() || !ed.isValid()) 
			return; // Exit if either date is invalid or incomplete
	
		// Check if end date is not before start date
		if (ed.isBefore(sd))
		{
			this.viewModel.amount(0);
			this.viewModel.amount_info(tr('End date cannot be before start date'));
			return;
		}
	
		// Enable amount editing for single day entries
		if (sd.isSame(ed))
		{
			this.viewModel.is_amount_editable(true);
		} else
		{
			this.viewModel.is_amount_editable(false);
		}

		try {
			let res = await Grape.fetches.postJSON('/leave/calculate_work_days', {
				_date_start: this.viewModel.date_start(),
				_date_end: this.viewModel.date_end(),
				leave_linked_id: this.viewModel.leave_linked_id()
			});
	
			if (res.status == 'OK')
				this.viewModel.amount(res.amount_days);
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.viewModel.amount(0);
			}
			else
			{
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
				this.viewModel.amount(0);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: tr('Error'), message: tr('Something went wrong while calculating leave days..') + error.message});
			this.viewModel.amount(0);
		}

		// check if date range selected doesn't already have leave assigned
		try {
			let res_range_free = await Grape.fetches.postJSON('/leave/is_leave_range_free', {
				date_start: this.viewModel.date_start(),
				date_end: this.viewModel.date_end(),
				employee_id: this.bindings.employee_id
			});
			if (res_range_free.status !== 'ERROR')
			{
				if (res_range_free.is_free != undefined)
				{
					this.viewModel.is_overlapping(!res_range_free.is_free);
				} else
				{
					this.viewModel.is_overlapping(false);
				}
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: tr('Error'), message: tr('Something went wrong while checking leave range..') + error.message});
		}
	
		// Get extra info - is this date range next to adjacent holiday?
		try {
			let res_holiday = await Grape.fetches.postJSON('/leave/is_date_range_adjacent_penalty_holiday', {
				'_date_start': this.viewModel.date_start(),
				'_date_end': this.viewModel.date_end(),
				'leave_linked_id': this.viewModel.leave_linked_id()
			});
			if (res_holiday.status == 'OK')
				this.viewModel.amount_info(res_holiday.result);
			else if (res_holiday.status == 'ERROR')
			{
				this.viewModel.amount_info('');
				Grape.alerts.apiError(res_holiday);
			}
			else
				this.viewModel.amount_info('');
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: tr('Error'), message: tr('Something went wrong while checking adjacent holidays..') + error.message});
		}

		// Get leave summary
		try {
			let res_leave = await Grape.fetches.getJSON('/leave/' + this.bindings.employee_id + '/summary/2000-01-01/' + this.viewModel.date_start(), {});
			if (res_leave.status !== 'ERROR')
				this.viewModel.leave_summary(ko.mapping.fromJS(res_leave));
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: tr('Error'), message: tr('Something went wrong while fetching leave summary...') + error.message});
		}
	};

	async process_NEXT_leave_restriction_queue_item(data)
	{
		if (this.leave_restriction_queue.length <= 0)
		{
			// queue is empty proceed to saving
			this.proceed_saving_leave(data);
			return;
		}

		let item = this.leave_restriction_queue.pop();

		let behaviour = item.behaviour;
		behaviour = 'warning_only'; // because this is the ADMIN side, we are going to force the behaviour to be warnings only since we dont want to block an admin person

		switch (behaviour)
		{
			case 'warning_only':
				let response = await Grape.alerts.confirm({	type: 'warning', title: tr('Notice'), message: item.message, accept_text: tr('Proceed'), cancel_text: tr('Cancel')});
				if (response)
					this.process_NEXT_leave_restriction_queue_item(data);
				else
				{
					document.getElementById("save_button").disabled = false;
					// cancelled ( it will stop here as we dont call next item to process)
				}
				break;
			case 'reject_leave_application':
				// this should never happen.. as we are forcing warnings above
				this.global_save_ok = false;
				Grape.alerts.alert({type: 'error', message: item.message, title: tr('Unable to save leave', 'Unable to save leave')});
				// ( it will stop here as we dont call next item to process)

				document.getElementById("save_button").disabled = false;

				break;
		}
	};

	async proceed_saving_leave(data)
	{
		let url;

		if (data.leave_taken_id == null)
		{
			data.leave_taken_id = -1;
			url = '/leave/save';
		}

		if (data.leave_taken_id != -1)
			url = '/leave/edit';

		if (this.global_save_ok == true)
		{
			// get leave type desc from the drop downs selected value
			let leave_type_description = $('#ddlLeaveType').find('option:selected').text();
			let leave_info = ko.utils.arrayFirst(this.viewModel.leave_summary().leave(), function (item) {
				return ko.unwrap(item.leave_type_id) === parseInt(data.leave_type_id);
			});

			let response = await Grape.alerts.confirm({type: 'success', title: 'Leave entry', message: tr('Please confirm the leave to add. \n')
				+ tr('Leave type: ') + leave_type_description + ', '
				+ tr('Start date: ') + data.date_start + ', '
				+ tr('End date: ') + data.date_end
			});
			
			if (response)
			{
				let res = await Grape.fetches.postJSON(url, data);
				if (res.status == 'OK')
				{
					// UPLOAD FILE
					if (this.viewModel.has_attachment() == true)
					{
						let formData = new FormData($('#batchuploadform')[0]);
						formData.append('employee_id', this.bindings.employee_id);
						formData.append('transaction_id', res.transaction_id);
						formData.append('name', $('#upload_input').val());

						var xhr = new XMLHttpRequest();
						xhr.onreadystatechange = async() => {
							if (xhr.readyState === 4)
							{
								await Grape.alerts.alert({type: 'success', message: tr('Successfully saved leave request.', 'Successfully saved leave request.'), title: tr('Success', 'Success')});
								this.close();
							}
						};
						xhr.open('post', '/employee/upload_leave_document', true);
						xhr.setRequestHeader('Accept', 'application/json');
						xhr.send(formData);
					}
					else
					{ 
						Grape.alerts.alert({type: 'success', message: tr('Successfully saved leave request.', 'Successfully saved leave request.'), title: tr('Success', 'Success')});
						this.close();
					}
				}
				else if (res.status == 'ERROR')
				{
					document.getElementById("save_button").disabled = false;
					Grape.alerts.apiError(res);
				}
				else
				{
					document.getElementById("save_button").disabled = false;
					Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
				}
			}
			if (Grape.config.public_settings.get_leave_warning > 0 && leave_info) {
				let available_balance = ko.unwrap(leave_info.available_balance);
				let leave_warning = parseFloat(Grape.config.public_settings.get_leave_warning);
				let requested_amount = ko.unwrap(this.viewModel.amount());

				if (requested_amount > available_balance)
				{
					await Grape.alerts.alert({
						type: 'warning',
						message: tr(`Successfully saved leave request. \n\n Please note: Your available days for ${leave_info.leave_type()} is now in the negative. Kindly contact your manager for more information.`),
						title: tr('Success')
					});
					this.close();
					return;
				}

				if (available_balance < leave_warning)
				{
					await Grape.alerts.alert({
						type: 'warning',
						message: tr(`Successfully saved leave request. \n\n Please note: Your ${leave_info.leave_type()} is almost depleted. Kindly contact your manager for more information.`),
						title: tr('Success')
					});
					this.close();
					return;
				}
			}
		}
		document.getElementById("save_button").disabled = false;
	};

	async init()
	{
		let res_linked = await Grape.fetches.postJSON('/leave/get_linked_leave', { employee_id: this.bindings.employee_id });
		if (res_linked.status !== 'ERROR')
			this.viewModel.available_leave_types(res_linked);

		let res_leave = await Grape.fetches.getJSON('/leave/' + this.bindings.employee_id + '/summary/2000-01-01/' + this.viewModel.summary_filter_earned_end(), {});
		if (res_leave.status !== 'ERROR')
				this.viewModel.leave_summary(ko.mapping.fromJS(res_leave));
		
				await this.load_calendar_colors();
				await this.load_holidays();
				await this.viewModel.load_events();
				this.viewModel.initialize_datepickers();
				this.add_custom_calendar_css();
	};

	async load_calendar_colors()
	{
		let res = await Grape.fetches.postJSON('/general/get_leave_color_combinations', {});
		generateCSScolorCombinations(res);
	}

	async load_holidays()
	{
		let holiday_res = await Grape.fetches.postJSON('/leave/get_holidays', {});

		if (holiday_res?.get_holidays)
			this.viewModel.holidays(holiday_res.get_holidays);
		else
			this.viewModel.holidays.removeAll();
	}

	add_custom_calendar_css()
	{
		let style = document.createElement('style');
		style.textContent = `
			.insert-leave-entry-dialog .flatpickr-calendar.end-date-calendar { 
				left: -1em;
			}

			.insert-leave-entry-dialog .flatpickr-calendar.static.open {
				display: inline-grid;
			}

			.insert-leave-entry-dialog .dayContainer {
				height: 15.5em;
				min-width: 238px;
				max-width: 238px;
			}

			.insert-leave-entry-dialog .flatpickr-days {
				width: 238px !important;
			}

			.insert-leave-entry-dialog .flatpickr-day {
				font-weight: 400;
				width: 34px;
				-webkit-flex-basis: 34px;
				-ms-flex-preferred-size: 34px;
				flex-basis: 34px;
				max-width: 34px;
				height: 33px;
				line-height: 31px;
				display: inline-block;
				margin: 0;
				text-align: center;
				padding: 0;
			}

			.insert-leave-entry-dialog .flatpickr-calendar.open, 
			.insert-leave-entry-dialog .flatpickr-calendar.inline {
				opacity: 1;
				max-height: 640px;
				visibility: visible;
				height: 241px;
				width: 238px;
			}

			.insert-leave-entry-dialog .flatpickr-month {
				height: 34px;
				display: flex;
				align-items: center;
				padding: 4px 0;
			}

			.insert-leave-entry-dialog .flatpickr-current-month {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 101%;
				height: 35px;
				padding: 1;
				font-size: 15px;
			}

			.insert-leave-entry-dialog .flatpickr-current-month .cur-month {
				margin-right: 4px;
			}

			.insert-leave-entry-dialog .numInputWrapper {
				width: 54px;
				margin-right: 3em;
				margin-left: 1.5em;
				font-size: 11px;
			}

			.insert-leave-entry-dialog .flatpickr-monthDropdown-months {
				font-size: 17px;
				font-weight: 400;
				height: 22px;
				padding: 0 4px;
			}

			.insert-leave-entry-dialog .numInput.cur-year {
				font-size: 14px;
				height: 22px;
				padding: 0 4px;
			}

			.insert-leave-entry-dialog .flatpickr-weekdays {
				height: 28px;
				display: flex;
				align-items: center;
			}

			.insert-leave-entry-dialog .flatpickr-weekday {
				width: 34px;
				max-width: 34px;
				flex: 0 0 34px;
				margin: 0;
				text-align: center;
				font-size: 12px;
			}

			.insert-leave-entry-dialog #datepicker_start + .flatpickr-calendar {
				left: -1em;
			}

			.insert-leave-entry-dialog .flatpickr-months .flatpickr-prev-month,
			.insert-leave-entry-dialog .flatpickr-months .flatpickr-next-month {
				height: 34px;
				padding: 4px;
				display: flex;
				align-items: center;
				justify-content: center;
			}`;
		document.head.appendChild(style);

		// Apply the custom class to the end date picker
		if (this.viewModel.end_date_picker)
			this.viewModel.end_date_picker.calendarContainer.classList.add('end-date-calendar');
	}
};

export default {
	name: 'InsertLeaveEntry',
	dialog_class: InsertLeaveEntryPage,
	template: template,
	template_filename: 'translation/dialogs/insert_leave_entry',
	provider: 'ps'
};
